// Pelukis bangunan: default box isometrik + pemanggil paintCode (kompilasi via paint.js).
import { TILE_W } from "./iso";
import { cssCol, shade } from "./color";
import { compilePaint, refHeight, FLOOR_H } from "./paint";
import { gambarSponsor, tempelPanel } from "./sponsorGambar";

// Pelukis default: box isometrik 3 sisi + garis lantai (dipakai jika bangunan belum punya paintCode)
export function paintDefault(ctx, P, U) {
  // Sisi kiri (gelap)
  ctx.fillStyle = shade(U.wall, 0.72);
  ctx.beginPath();
  ctx.moveTo(...P.left);
  ctx.lineTo(...P.bottom);
  ctx.lineTo(P.bottom[0], P.bottom[1] - P.height);
  ctx.lineTo(P.left[0], P.left[1] - P.height);
  ctx.closePath();
  ctx.fill();
  // Sisi kanan (sedang)
  ctx.fillStyle = shade(U.wall, 0.86);
  ctx.beginPath();
  ctx.moveTo(...P.bottom);
  ctx.lineTo(...P.right);
  ctx.lineTo(P.right[0], P.right[1] - P.height);
  ctx.lineTo(P.bottom[0], P.bottom[1] - P.height);
  ctx.closePath();
  ctx.fill();
  // Atap
  ctx.fillStyle = cssCol(U.roof);
  ctx.beginPath();
  ctx.moveTo(P.top[0], P.top[1] - P.height);
  ctx.lineTo(P.right[0], P.right[1] - P.height);
  ctx.lineTo(P.bottom[0], P.bottom[1] - P.height);
  ctx.lineTo(P.left[0], P.left[1] - P.height);
  ctx.closePath();
  ctx.fill();
  // Garis lantai
  if (U.floors > 1) {
    ctx.strokeStyle = "rgba(0,0,0,0.15)";
    ctx.lineWidth = 1;
    for (let f = 1; f < U.floors; f++) {
      const zf = f * U.floorH;
      ctx.beginPath();
      ctx.moveTo(P.left[0], P.left[1] - zf);
      ctx.lineTo(P.bottom[0], P.bottom[1] - zf);
      ctx.lineTo(P.right[0], P.right[1] - zf);
      ctx.stroke();
    }
  }
}

// Lukis satu bangunan ke konteks g memakai proyeksi proj(gx,gy)→layar & zoom tertentu.
// Jika penempatan menunjuk varian (b.vid), pakai paintCode varian itu.
export function paintBuildingTo(g, b, def, proj, zoom, night) {
  let effDef = def;
  if (b.vid && def?.variants?.length) {
    const v = def.variants.find(x => x.vid === b.vid);
    if (v) effDef = { ...def, paintCode: v.paintCode, _pkey: def.bid + ":" + v.vid };
  }
  const rot = b.rot || 0;
  let w = effDef?.w || 1;
  let h = effDef?.h || 1;
  if (rot % 2 === 1) [w, h] = [h, w]; // rotasi ganjil = tapak tertukar
  const floors = effDef?.floors ?? 1;
  const floorH = FLOOR_H * zoom;
  const height = refHeight(floors, w, h, zoom); // uncapped: proporsional luas tapak

  // Sudut tapak, lalu putar penamaan sudut sebanyak rot x 90°
  const corners = [proj(b.x, b.y), proj(b.x + w, b.y), proj(b.x + w, b.y + h), proj(b.x, b.y + h)];
  const rc = [0, 1, 2, 3].map(i => corners[(i + rot) % 4]);
  const P = { top: rc[0], right: rc[1], bottom: rc[2], left: rc[3], height };
  const U = {
    zoom,
    floors,
    floorH,
    span: (w + h) * (TILE_W / 2) * zoom,
    tileW: TILE_W * zoom,
    wall: effDef?.wall || [210, 195, 170],
    roof: effDef?.roof || [170, 70, 55],
    cssCol, shade,
    def: effDef, night, time: 0,
    signEdit: b.signEdit || null // override nama/warna/ukuran huruf timbul (diedit di editor)
  };

  const fn = effDef?.paintCode ? compilePaint(effDef._pkey || effDef.bid, effDef.paintCode) : null;
  if (fn) {
    try { fn(g, P, U); } catch { paintDefault(g, P, U); }
  } else paintDefault(g, P, U);
  // Billboard sponsor: gambar iklan ditempel ke bidang panel (metadata def.panel) setelah rangka dilukis
  const gid = b.sponsor?.gambar_id;
  if (effDef?.panel && gid) {
    const img = gambarSponsor(gid);
    if (img) tempelPanel(g, P, TILE_W * zoom, effDef.panel, img);
  }
}
